var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 0.741943H2.6875C2.10753 0.742564 1.55149 0.973231 1.14139 1.38333C0.731288 1.79343 0.50062 2.34947 0.5 2.92944V12.3044C0.50062 12.8844 0.731288 13.4405 1.14139 13.8506C1.55149 14.2607 2.10753 14.4913 2.6875 14.4919H15.8125C16.3925 14.4913 16.9485 14.2607 17.3586 13.8506C17.7687 13.4405 17.9994 12.8844 18 12.3044V2.92944C17.9994 2.34947 17.7687 1.79343 17.3586 1.38333C16.9485 0.973231 16.3925 0.742564 15.8125 0.741943ZM15.2586 4.3603L9.63359 8.7353C9.52391 8.82057 9.38893 8.86687 9.25 8.86687C9.11107 8.86687 8.97609 8.82057 8.86641 8.7353L3.24141 4.3603C3.17532 4.31039 3.11981 4.24785 3.0781 4.1763C3.03639 4.10475 3.00932 4.02563 2.99846 3.94353C2.98759 3.86143 2.99315 3.77799 3.01482 3.69806C3.03648 3.61812 3.07381 3.54329 3.12465 3.47791C3.17548 3.41253 3.2388 3.35791 3.31093 3.31721C3.38306 3.27652 3.46255 3.25056 3.5448 3.24085C3.62704 3.23115 3.7104 3.23788 3.79002 3.26067C3.86964 3.28345 3.94394 3.32184 4.00859 3.37358L9.25 7.45015L14.4914 3.37358C14.6225 3.27461 14.7872 3.2312 14.95 3.25274C15.1129 3.27429 15.2607 3.35905 15.3615 3.48871C15.4623 3.61837 15.508 3.7825 15.4887 3.9456C15.4695 4.1087 15.3868 4.25768 15.2586 4.3603Z",
    fill: "#01295F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.5bcae5d79c9286cd72341e5deb2eb42d.svg";
export { ForwardRef as ReactComponent };